// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { HOME_SET_SITE_MAP_DATA } from './constants';

export function setSiteMapData(data) {
  return {
    type: HOME_SET_SITE_MAP_DATA,
    data: data,
  };
}

export function reducer(state, action) {
  // console.log('Sitemap data homepage ---------', action.data);
  switch (action.type) {
    case HOME_SET_SITE_MAP_DATA:
      return {
        ...state,
        sitemapHomepage: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setSiteMapData.js